import { createAsyncThunk } from '@reduxjs/toolkit';
import { saveLeadV1Info } from 'shared/services/saveLead';
import { setVisible } from 'shared/slices/modalSlice';
import { addNotification } from 'shared/slices/notificationsSlice';
import { ELeadStatus, TSaveLeadParams } from 'shared/types/features';
import { IThunkApi } from 'shared/types/redux/';

export const saveLead = createAsyncThunk<ELeadStatus, TSaveLeadParams, IThunkApi>(
  'lead/saveLead',
  async (parameters, thunkApi) => {
    const { extra, rejectWithValue, dispatch } = thunkApi;

    try {
      await saveLeadV1Info({
        httpApi: extra.httpApi,
        logger: extra.logger,
        userId: extra.custom.cianUserId,
        ...parameters,
      });

      dispatch(setVisible(false));

      return ELeadStatus.Success;
    } catch (e) {
      extra.logger.error(e, { description: 'Ошибка api /api/hosts/v1/save-form-request' });

      dispatch(
        addNotification({
          type: 'error',
          text: 'Что-то пошло не так, попробуйте позже',
        }),
      );

      return rejectWithValue(ELeadStatus.Failed);
    }
  },
);
